/* global html2pdf */
function downloadReceiptPDF() {
  const element = document.getElementById("Receipt-invoice");

  const options = {
    margin: 0.3,
    filename: "TheVisaCo-Receipt.pdf",
    image: {
      type: "jpeg",
      quality: 1,
    },
    html2canvas: {
      scale: 2,
      useCORS: true,
      logging: false,
    },
    jsPDF: {
      unit: "in",
      format: "a4",
      orientation: "portrait",
    },
  };

  html2pdf().set(options).from(element).save();
}

const customRound = (num) => {
  const decimal = num - Math.floor(num);
  if (decimal > 0.5) {
    return Math.ceil(num);
  }
  return Math.floor(num);
};

const getCountryName = (countryValue) => {
  if (!countryValue) return "";
  return countryValue;
};

const getPlanTypeLabel = (type) => {
  switch (type) {
    case "data": return "Data Only";
    case "unlimited": return "Unlimited";
    case "bundle": return "Voice + SMS + Data";
    default: return type;
  }
};

const DOC_KEYS = ["aadhaarFront","aadhaarBack","passportAppFront","passportAppBack","panFront","panBack","passportFront","passportBack","bankStatement","visaPhoto","biometric","flightTicket","travelInsurance","invitationLetter","otherDoc"];

const DOC_LABELS = {
  aadhaarFront: "Aadhaar Card \u2013 Front",
  aadhaarBack: "Aadhaar Card \u2013 Back",
  passportAppFront: "Existing Passport \u2013 Front",
  passportAppBack: "Existing Passport \u2013 Back",
  panFront: "PAN Card \u2013 Front",
  panBack: "PAN Card \u2013 Back",
  passportFront: "Passport \u2013 First Page",
  passportBack: "Passport \u2013 Last Page",
  bankStatement: "Bank Statement (3 months)",
  visaPhoto: "Photo for Visa",
  biometric: "Biometric Receipt",
  flightTicket: "Flight Ticket",
  travelInsurance: "Travel Insurance",
  invitationLetter: "Invitation Letter",
  otherDoc: "Other Document",
};

const createDocsTable = (applicant) => {
  const rows = DOC_KEYS.map((key) => {
    const doc = applicant[key];
    const uploaded = !!(doc?.name || doc?._name || doc?.info?.name);
    return `
      <tr>
        <td>${DOC_LABELS[key]}</td>
        <td style="text-align:right">${uploaded ? '<span class="Receipt-docs-tick">\u2713</span>' : '<span class="Receipt-docs-cross">\u2717</span>'}</td>
      </tr>`;
  }).join("");
  return `
    <div class="Receipt-docs-section">
      <div class="Receipt-docs-title">Documents</div>
      <table class="Receipt-docs-table">
        ${rows}
      </table>
    </div>`;
};

 const PAYMENT_CONVENIENCE_FEES = {
   upi: 0,
   netbanking: 1.5,
   card: 2.5,
   wallet: 0,
   reward: 0,
 };

const TAX_RATE = 0.18;

 const PAYMENT_METHODS = [
   { id: "upi", label: "UPI", description: "Pay via UPI ID or QR code — No convenience fee" },
   { id: "netbanking", label: "Net Banking", description: "All major banks supported — ₹1.50 convenience fee" },
   { id: "card", label: "Debit / Credit Card", description: "Visa, Mastercard, Amex, RuPay — ₹2.50 convenience fee" },
   { id: "wallet", label: "Pay with Reward Money", description: "Use your available reward balance — No convenience fee" },
   { id: "reward", label: "Pay by Reward", description: "Use your wallet balance — No convenience fee" },
 ];

export const generateReceiptHTML = ({ item, quantity, payMethod, billingDetails, orderId, currency, appliedDiscount = 0, logoSrc, pdf = false, upiId, bank, card, simType, inr = false, overrides = {}, applicants = [], authorisedName, authorisedId, authorisedPhone, authorisedCountryCode, serviceDetailRows = [] }) => {
  const INR_RATE = inr ? 1 : 83;
  const fmt = (val) => `&#8377;${customRound(val * INR_RATE).toLocaleString("en-IN")}`;

  const convFee = overrides.convFee !== undefined ? overrides.convFee : (inr ? 0 : (PAYMENT_CONVENIENCE_FEES[payMethod] || 0));
  const subtotal = overrides.subtotal !== undefined ? overrides.subtotal : (item.price * quantity);
  const tax = overrides.tax !== undefined ? overrides.tax : (subtotal * TAX_RATE);
  const discount = overrides.discount !== undefined ? overrides.discount : (appliedDiscount || 0);
  const total = overrides.total !== undefined ? overrides.total : (subtotal + tax + convFee - discount);
  const discountLabel = overrides.discountLabel || "Discount";
  const subtotalLabel = overrides.subtotalLabel || "Subtotal";
  const hideSubtotal = overrides.hideSubtotal || false;
  const extraRows = overrides.extraRows || [];
  const govtFee = overrides.govtFee !== undefined ? overrides.govtFee : null;
  const paymentMethodLabel = overrides.paymentMethodLabel || null;
  const date = new Date().toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  const pmLabel = PAYMENT_METHODS.find(p => p.id === payMethod)?.label || payMethod;

  const firstName = billingDetails?.firstName || "";
  const lastName = billingDetails?.lastName || "";
  const fullName = firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName || "";
  const email = billingDetails?.email || "";
  const countryName = getCountryName(billingDetails?.country);
  const accountType = billingDetails?.accountType || "";
  const companyName = billingDetails?.companyName || "";
  const planDetail = `${item.data}${simType === "esim" && item.validity ? ` \u00B7 ${item.validity} Days` : ""} \u00B7 ${getPlanTypeLabel(item.type)}${quantity > 1 ? ` \u00B7 Qty: ${quantity}` : ""}`;

  const bg = pdf ? "#ffffff" : "#f5f9ff";
  const cardBg = pdf ? "#ffffff" : "rgba(255,255,255,0.86)";
  const cardFilter = pdf ? "" : "backdrop-filter: blur(18px); -webkit-backdrop-filter: blur(18px);";
  const cardBorder = pdf ? "1px solid #e2e8f0" : "1px solid rgba(255,255,255,0.8)";
  const dashedBefore = pdf ? "" : "body::before { content: ''; position: fixed; width: 900px; height: 900px; border: 2px dashed rgba(59,130,246,0.12); border-radius: 120px; top: -250px; right: -220px; transform: rotate(12deg); pointer-events: none; }";
  const dashedAfter = pdf ? "" : "body::after { content: ''; position: fixed; width: 700px; height: 700px; border: 2px dashed rgba(59,130,246,0.09); border-radius: 90px; bottom: -180px; left: -180px; transform: rotate(-8deg); pointer-events: none; }";
  const cardBefore = pdf ? "" : ".Receipt-card::before { content: ''; position: absolute; inset: 0; background: linear-gradient(135deg, rgba(255,255,255,0.35), rgba(255,255,255,0.08)); pointer-events: none; }";
  const boxBg = pdf ? "#f8fafc" : "rgba(255,255,255,0.58)";
  const rowBg = pdf ? "#f8fafc" : "rgba(255,255,255,0.65)";
  const sumBg = pdf ? "#f8fafc" : "rgba(255,255,255,0.62)";
  const boxShadow = pdf ? "0 1px 3px rgba(0,0,0,0.06)" : "inset 0 1px 0 rgba(255,255,255,0.95), 0 4px 12px rgba(15,23,42,0.03)";

  const bp = pdf ? "10px 0" : "40px";
  const cp = pdf ? "20px 24px" : "42px";
  const h1s = pdf ? "28px" : "40px";
  const hmb = pdf ? "16px" : "40px";
  const gg = pdf ? "10px" : "22px";
  const gmb = pdf ? "8px" : "20px";
  const gpt = pdf ? "12px" : "24px";
  const gpb = pdf ? "12px" : "24px";
  const tpad = pdf ? "10px 12px" : "22px 18px";
  const tsp = pdf ? "0 6px" : "0 14px";
  const smt = pdf ? "14px" : "34px";
  const sw = pdf ? "100%" : "320px";
  const spt = pdf ? "14px" : "28px";
  const spb = pdf ? "14px" : "28px";
  const srm = pdf ? "6px" : "18px";
  const stpt = pdf ? "10px" : "18px";
  const stmt = pdf ? "6px" : "12px";
  const sts = pdf ? "17px" : "21px";
  const fm = pdf ? "16px" : "42px";
  const fpt = pdf ? "10px" : "20px";
  const acp = pdf ? "12px" : "20px";
  const acm = pdf ? "8px" : "14px";
  const agg = pdf ? "4px 10px" : "10px 24px";
  const lw = pdf ? "180px" : "220px";

  const css = `
  * { margin: 0; padding: 0; box-sizing: border-box; font-family: "Inter", "Segoe UI", sans-serif; }
  body { background: ${bg}; padding: ${bp}; color: #0f172a; position: relative; overflow: visible; }
  ${dashedBefore}
  ${dashedAfter}
  .Receipt-wrapper { max-width: ${pdf ? "100%" : "980px"}; margin: auto; position: relative; z-index: 2; }
  .Receipt-card { background: ${cardBg}; ${cardFilter} border: none; border-radius: ${pdf ? "8px" : "12px"}; padding: ${cp}; box-shadow: 0 10px 40px rgba(15,23,42,0.06), inset 0 1px 0 rgba(255,255,255,0.95); position: relative; overflow: visible; }
  ${cardBefore}
  .Receipt-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: ${hmb}; gap: 20px; position: relative; z-index: 2; }
  .Receipt-logo-box { display: flex; align-items: center; }
  .Receipt-logo-box img { width: ${lw}; height: auto; object-fit: contain; }
  .Receipt-heading { text-align: right; }
  .Receipt-heading h1 { font-size: ${h1s}; color: #0f172a; letter-spacing: 3px; margin-bottom: 10px; font-weight: 300; }
  .Receipt-meta { color: #000000; font-size: 14px; line-height: 1.7; }
  .Receipt-glass-grid { display: grid; grid-template-columns: 1fr 1fr; gap: ${gg}; margin-bottom: ${gmb}; position: relative; z-index: 2; }
  .Receipt-glass-box { background: ${boxBg}; border: none; border-radius: 12px; padding: ${gpt} ${gpb}; box-shadow: ${boxShadow}; }
  .Receipt-glass-title { font-size: 12px; text-transform: uppercase; letter-spacing: 1.6px; color: #2563eb; margin-bottom: 14px; font-weight: 700; }
  .Receipt-glass-content { line-height: 1.7; font-size: 15px; color: #000000; }
  .Receipt-table { width: 100%; border-collapse: separate; border-spacing: 0; position: relative; z-index: 2; margin-top: 100px; }
  .Receipt-table thead th { text-align: left; padding: 14px 18px; font-size: 12px; text-transform: uppercase; letter-spacing: 1.3px; color: #000000; background: ${rowBg}; }
  .Receipt-table thead th:first-child { border-top-left-radius: 12px; }
  .Receipt-table thead th:last-child { text-align: right; border-top-right-radius: 12px; }
  .Receipt-table tbody tr { background: ${rowBg}; box-shadow: 0 4px 14px rgba(15,23,42,0.03), inset 0 1px 0 rgba(255,255,255,0.95); }
  .Receipt-table tbody td { padding: ${tpad}; font-size: 15px; color: #000000; }
  .Receipt-table tbody td:last-child { text-align: right; font-weight: 600; color: #000000; }
  .Receipt-table tbody tr:last-child td:first-child { border-bottom-left-radius: 12px; }
  .Receipt-table tbody tr:last-child td:last-child { border-bottom-right-radius: 12px; }
  .Receipt-table tbody td small { display: block; font-size: 13px; color: #000000; margin-top: 3px; font-weight: 400; }
  .Receipt-summary { display: flex; justify-content: flex-end; margin-top: ${smt}; position: relative; z-index: 2; }
  .Receipt-summary-box { width: ${sw}; background: ${sumBg}; border: none; border-radius: 12px; padding: ${spt} ${spb}; box-shadow: ${boxShadow}; }
  .Receipt-summary-row { display: flex; justify-content: space-between; margin-bottom: ${srm}; font-size: 15px; color: #000000; }
  .Receipt-summary-total { padding-top: ${stpt}; margin-top: ${stmt}; font-size: ${sts}; font-weight: 700; color: #000000; }
  .Receipt-discount { color: #dc2626; }
  .Receipt-footer { margin-top: ${fm}; padding-top: ${fpt}; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px; font-size: 14px; color: #000000; position: relative; z-index: 2; }
  .Receipt-applicants-title { font-size: 12px; text-transform: uppercase; letter-spacing: 1.3px; color: #2563eb; font-weight: 700; margin-bottom: 14px; }
  .Receipt-applicants-section { margin-top: ${gmb}; margin-bottom: ${gmb}; position: relative; z-index: 2; background: ${boxBg}; border: none; border-radius: 12px; padding: ${acp}; box-shadow: ${boxShadow}; }
  .Receipt-applicant-card { background: ${boxBg}; border: none; border-radius: 12px; padding: ${acp}; margin-bottom: ${acm}; box-shadow: ${boxShadow}; }
  .Receipt-applicant-header { font-size: 11px; text-transform: uppercase; letter-spacing: 1.3px; color: #000000; margin-bottom: 14px; font-weight: 600; }
  .Receipt-applicant-grid { display: grid; grid-template-columns: 1fr 1fr; gap: ${agg}; }
  .Receipt-applicant-field { display: flex; flex-direction: column; gap: 2px; }
  .Receipt-field-label { font-size: 10px; text-transform: uppercase; letter-spacing: 0.8px; color: #000000; font-weight: 600; }
  .Receipt-field-value { font-size: 14px; color: #000000; font-weight: 400; }
  .Receipt-flight-details { margin-top: 14px; padding-top: 12px; }
  .Receipt-flight-title { font-size: 11px; text-transform: uppercase; letter-spacing: 1.3px; color: #000000; margin-bottom: 10px; font-weight: 600; }
  .Receipt-docs-section { margin-top: 14px; padding-top: 12px; }
  .Receipt-docs-title { font-size: 11px; text-transform: uppercase; letter-spacing: 1.3px; color: #000000; margin-bottom: 10px; font-weight: 600; }
  .Receipt-docs-table { width: 100%; border-collapse: collapse; }
  .Receipt-docs-table td { padding: ${pdf ? "4px 0" : "6px 0"}; font-size: 13px; color: #000000; }
  .Receipt-docs-table tr:last-child td { border-bottom: none; }
  .Receipt-docs-tick { color: #059669; font-weight: 700; font-size: 15px; }
  .Receipt-docs-cross { color: #dc2626; font-weight: 700; font-size: 15px; }
  @page { size: A4; margin: 10mm; }
  @media print { body { background: #fff; padding: 0; } }
  @media (max-width: 768px) { body { padding: 20px; } .Receipt-header { flex-direction: column; } .Receipt-heading { text-align: left; } .Receipt-glass-grid { grid-template-columns: 1fr; } .Receipt-summary { justify-content: stretch; } .Receipt-summary-box { width: 100%; } .Receipt-card { padding: 24px; } .Receipt-footer { flex-direction: column; align-items: flex-start; } .Receipt-applicant-grid { grid-template-columns: 1fr; } }
  `;

  return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>TheVisaCo Receipt \u2014 ${orderId}</title>
<style>${css}</style>
</head>
<body>
<div class="Receipt-wrapper">
  <div class="Receipt-card" id="Receipt-invoice">
    <div class="Receipt-header">
      <div class="Receipt-logo-box">
        ${logoSrc ? `<img src="${logoSrc}" alt="TheVisaCo Logo">` : `<span style="font-size:28px;font-weight:700;color:#0b4fd9;">&#127758; TheVisaCo</span>`}
      </div>
      <div class="Receipt-heading">
        <h1>INVOICE</h1>
        <div class="Receipt-meta">
          Receipt No: ${orderId}<br>
          Date: ${date}<br>
          Status: <span style="color:#059669;font-weight:600;">Paid</span>
        </div>
      </div>
    </div>
    <div class="Receipt-glass-grid">
      <div class="Receipt-glass-box">
        <div class="Receipt-glass-title">Bill To</div>
        <div class="Receipt-glass-content">
          ${fullName ? `<strong>${fullName}</strong><br>` : ""}
          ${accountType ? `${accountType}<br>` : ""}
          ${email ? `${email}<br>` : ""}
          ${companyName ? `Company: ${companyName}<br>` : ""}
          ${countryName || ""}
          ${billingDetails?.address ? `${billingDetails.address}<br>` : ""}
          ${billingDetails?.city ? `${billingDetails.city}${billingDetails?.state ? `, ${billingDetails.state}` : ""}${billingDetails?.pincode ? ` \u2013 ${billingDetails.pincode}` : ""}<br>` : ""}
          ${billingDetails?.phone ? `Phone: ${billingDetails.phoneCode || ""} ${billingDetails.phone}<br>` : ""}
        </div>
      </div>
      <div class="Receipt-glass-box">
        <div class="Receipt-glass-title">Payment Information</div>
        <div class="Receipt-glass-content">
          Method: ${pmLabel}<br>
          ${payMethod === "upi" && upiId ? `UPI ID: ${upiId}<br>` : ""}
          ${payMethod === "netbanking" && bank ? `Bank: ${bank}<br>` : ""}
          ${payMethod === "card" && card?.number ? `Card: ****${card.number.slice(-4)}<br>` : ""}
          ${simType === "esim" || simType === "physical" ? `SIM: ${simType === "esim" ? "eSIM" : "Physical SIM"}<br>` : ""}
          Plan: ${item.label}${simType === "esim" && item.validity ? ` \u00B7 ${item.validity} Days` : ""}<br>
          ${authorisedName ? `
          <div style="margin-top:10px;padding-top:10px;border-top:1px solid #94a3b8;">
            <strong>Authorised Person</strong><br>
            ${authorisedName}<br>
            ${authorisedId ? `ID: ${authorisedId}<br>` : ""}
            ${authorisedPhone ? `Phone: ${authorisedCountryCode || ""} ${authorisedPhone}` : ""}
          </div>` : ""}
        </div>
      </div>
    </div>
    ${applicants.length > 0 ? `
    <div class="Receipt-applicants-section">
      <div class="Receipt-applicants-title">Applicant Details</div>
      ${applicants.map((a, i) => `
      <div class="Receipt-applicant-card">
        <div class="Receipt-applicant-header">Applicant ${i + 1}</div>
        <div class="Receipt-applicant-grid">
          ${a.firstName ? `<div class="Receipt-applicant-field"><span class="Receipt-field-label">First Name</span><span class="Receipt-field-value">${a.firstName}</span></div>` : ""}
          ${a.lastName ? `<div class="Receipt-applicant-field"><span class="Receipt-field-label">Last Name</span><span class="Receipt-field-value">${a.lastName}</span></div>` : ""}
          ${a.gender ? `<div class="Receipt-applicant-field"><span class="Receipt-field-label">Gender</span><span class="Receipt-field-value">${a.gender}</span></div>` : ""}
          ${a.email ? `<div class="Receipt-applicant-field"><span class="Receipt-field-label">Email</span><span class="Receipt-field-value">${a.email}</span></div>` : ""}
          ${a.dob ? `<div class="Receipt-applicant-field"><span class="Receipt-field-label">Date of Birth</span><span class="Receipt-field-value">${a.dob}</span></div>` : ""}
          ${a.maritalStatus ? `<div class="Receipt-applicant-field"><span class="Receipt-field-label">Marital Status</span><span class="Receipt-field-value">${a.maritalStatus}</span></div>` : ""}
          ${a.passportNumber ? `<div class="Receipt-applicant-field"><span class="Receipt-field-label">Passport Number</span><span class="Receipt-field-value">${a.passportNumber}</span></div>` : ""}
          ${a.phone ? `<div class="Receipt-applicant-field"><span class="Receipt-field-label">Phone</span><span class="Receipt-field-value">${a.phoneCode || ""} ${a.phone}</span></div>` : ""}
        </div>
        ${createDocsTable(a)}
        ${a.flight && (a.flight.arrivalDate || a.flight.departureDate) ? `
        <div class="Receipt-flight-details">
          <div class="Receipt-flight-title">Flight Details</div>
          <div class="Receipt-applicant-grid">
            ${a.flight.arrivalDate ? `<div class="Receipt-applicant-field"><span class="Receipt-field-label">Arrival Date</span><span class="Receipt-field-value">${a.flight.arrivalDate}</span></div>` : ""}
            ${a.flight.departureDate ? `<div class="Receipt-applicant-field"><span class="Receipt-field-label">Departure Date</span><span class="Receipt-field-value">${a.flight.departureDate}</span></div>` : ""}
          </div>
        </div>` : ""}
      </div>`).join("")}
      <div style="height:20px"></div>
    </div>` : ""}
    <table class="Receipt-table">
      <thead>
        <tr>
          <th>Service</th>
          <th>Rate</th>
          <th>Qty</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            ${item.label}
            ${item.countryName ? `<small>${item.countryName}</small>` : ""}
            <small>${item.data}${simType === "esim" && item.validity ? ` \u00B7 ${item.validity} Days` : ""}</small>
            ${serviceDetailRows.map(d => `<small>${d}</small>`).join("")}
          </td>
          <td>${fmt(item.price)}</td>
          <td>${quantity}</td>
          <td>${fmt(subtotal)}</td>
        </tr>
      </tbody>
    </table>
    <div class="Receipt-summary">
      <div class="Receipt-summary-box">
        ${govtFee !== null ? `
        <div class="Receipt-summary-row">
          <span>Government Fee</span>
          <span>${fmt(govtFee)}</span>
        </div>
        <div class="Receipt-summary-row">
          <span>Service Fee</span>
          <span>${fmt(subtotal)}</span>
        </div>
        <div class="Receipt-summary-row">
          <span>GST (18%)</span>
          <span>${fmt(tax)}</span>
        </div>
        <div class="Receipt-summary-row">
          <span>Convenience Fee (${pmLabel})</span>
          <span>${fmt(convFee)}</span>
        </div>
        ${discount > 0 ? `
        <div class="Receipt-summary-row Receipt-discount">
          <span>${discountLabel}</span>
          <span>\u2212${fmt(discount)}</span>
        </div>` : ""}
        <div class="Receipt-summary-row Receipt-summary-total">
          <span>Total</span>
          <span>${fmt(total)}</span>
        </div>
        ` : `
        ${!hideSubtotal ? `
        <div class="Receipt-summary-row">
          <span>${subtotalLabel}</span>
          <span>${fmt(subtotal)}</span>
        </div>` : ""}
        ${extraRows.map(r => `
        <div class="Receipt-summary-row">
          <span>${r.label}</span>
          <span>${fmt(r.value)}</span>
        </div>`).join("")}
        <div class="Receipt-summary-row">
          <span>GST (18%)</span>
          <span>${fmt(tax)}</span>
        </div>
        <div class="Receipt-summary-row">
          <span>Convenience Fee (${pmLabel})</span>
          <span>${fmt(convFee)}</span>
        </div>
        ${discount > 0 ? `
        <div class="Receipt-summary-row Receipt-discount">
          <span>${discountLabel}</span>
          <span>\u2212${fmt(discount)}</span>
        </div>` : ""}
        <div class="Receipt-summary-row Receipt-summary-total">
          <span>Total</span>
          <span>${fmt(total)}</span>
        </div>
        `}
      </div>
    </div>
    <div class="Receipt-footer">
      <div>\u00A9 2026 TheVisaCo</div>
      <div>\uD83C\uDF10 www.thevisaco.com</div>
      <div>\u2709 support@thevisaco.com</div>
    </div>
  </div>
</div>
</body>
</html>`;
};
